import React from "react";
var __jsx = React.createElement;
import stl from "./SubMenuContainer.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useIsBrowser from "@hooks/useIsBrowser";
function SubMenuContainer(_ref) {
  var name = _ref.name,
    onClick = _ref.onClick,
    component = _ref.component,
    count = _ref.count,
    selectedFiltersCount = _ref.selectedFiltersCount,
    handleCloseFilter = _ref.handleCloseFilter;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var canUseDOM = useIsBrowser();
  return /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("div", {
    id: "filter-submenu-header",
    className: [stl.headingPart].join(" "),
    onClick: handleCloseFilter
  }, /*#__PURE__*/React.createElement("img", {
    className: "m-hide",
    src: CDN_LINK + "/assets/images/arrAcc.svg",
    width: 12,
    height: 7,
    alt: "arrow"
  }), /*#__PURE__*/React.createElement("span", {
    id: "filter-submenu-cancel-btn",
    className: [stl.backMob, "m-show"].join(" ")
  }, t("إلغاء")), /*#__PURE__*/React.createElement("strong", {
    id: "filter-submenu-title"
  }, name)), /*#__PURE__*/React.createElement("div", {
    id: "filter-submenu-content",
    className: [stl.componentContainer, canUseDOM && document.getElementById("LineCamp") != null && window.innerWidth > 1024 && document.getElementById("LineCamp").style.display != "none" ? stl.campHeight : undefined].join(" ")
  }, component), !(count == 0 && selectedFiltersCount > 0) && /*#__PURE__*/React.createElement("button", {
    id: "filter-submenu-done-btn",
    onClick: onClick,
    className: stl.DoneBtn
  }, t("تم")));
}
export default SubMenuContainer;